module.exports = __webpack_public_path__ + "bfe5ab52985ff6e26ca3ec6c87be7644.png";